import DownloadSvg from '../../../assets/download.svg?react';
import { IconProps } from '../../types/IconProps';

export function Download({ size = 20, ...props }: IconProps) {
  return <DownloadSvg data-testid="download-icon" width={size} height={size} {...props} />;
}

export default Download;
